import { DatePipe, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PaginationService } from 'ngx-pagination';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { environment } from '../../../../../../environments/environment';
import { PostPromote, IPostPromote } from '../../../../../../models/postPromote.model';
import { PostPromoteService } from '../../../../../../services/postPromote.service';
import { ProductService } from '../../../../../../services/product.service';
import { CustomValidators } from '../../../../../customValidators';
import { NameValidator } from '../../../../validators/name.validator';
import { SubscriptionService } from '../../../../../../services/subscription.service';
import { ISubscriptionModel, SubscriptionModel } from '../../../../../../models/subscription.model';
import { UserService } from '../../../../../../services/user.service';
import { User } from '../../../../../../models/user.model';
import { IOrderItem, OrderItem } from '../../../../../../models/orderItem.model';
import { OrderService } from '../../../../../../services/order.service';
import { IOrder } from '../../../../../../models/order.model';
import { Product } from '../../../../../../models/product.model';

@Component({
  selector: 'app-list-pass-user',
  templateUrl: './list-pass-user.component.html',
  styleUrls: ['./list-pass-user.component.scss']
})
export class ListPassUserComponent implements OnInit {

  slugNombreAnnoncePublie = "max.post.published";
  slugNombreEmploiPublie = "max.job.post.published";
  slugNombreBoutique = "kahpoo.max.shop";
  slugDureeAnnoncePublie = "duration.post.published.hour";
  slugDureeEmploiPublie = "duration.job.post.published.hour";
  slugAnnonceMiseEnAvant = "max.post.promote";
  slugAnnonceEmploiMiseEnAvant = "max.job.post.promote";
  slugDureeAnnonceMiseEnAvant = "duration.post.promote.hour";
  slugDureeEmploiMiseEnAvant = "duration.job.post.promote.hour";
  slugOrganisationDesPromotions = "max.seller.promotion";
  slugPubliciteSponsoriseAnnonce = "max.post.sponsored";
  slugAnnonceBanniere = "max.post.banner";
  slugEnableGestionAgenda = "enable.seller.agenda.management";
  slugEnableSellerPromotion = "enable.seller.promotion";
  slugPublicationReseauxSociaux = "max.published.social.media";
  slugEnableGestionDesCommandes = "enable.seller.order.management";
  slugEnableStatistiqueClient = "enable.review.customer.statistic";
  slugEnableCampagneCommunicationPromotion = "enable.campaign.promotion";
  slugDureeAbonnement = "duration.subscription.hour";
  @ViewChild('closebutton1') closebutton1;
  isFiltreDate: boolean;
  search: any;
  allSubscribe: SubscriptionModel[] = [];
  allSubscribeTmp: SubscriptionModel[] = [];
  allUser: User[] = [];
  username:  User[] = [];
  CurrentUsername: string
  photoUrl: string
  // @ts-ignore
  currentSubscribe: ISubscriptionModel = [];
  order: IOrder[] = []
  pageNumber: number = 1;
  pageSize: number = 15;
  totalItems: number;
  sorted = false;
  sorted1 = false;
  sorted01 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  isTrueName = false;
  @ViewChild('closebutton') closebutton;
  url_photo: String;
  constructor(private fb: FormBuilder, private postPromoteService: PostPromoteService ,
              private router :Router, private productService : ProductService,
              private datePipe: DatePipe,private susbscriptionService: SubscriptionService,
              private userService: UserService, subproductService: ProductService,
              private orderItemService: OrderService,
              private location: Location,private paginationService: PaginationService) { }

  ngOnInit(): void {
    this.url_photo = environment.url_photo;
    this.loadSubscription();
  }

  goBack(): void {
  this.location.back();
  }

  model = {
    description: ''
  };

  enablePostPromote(prost:PostPromote){
    Swal.fire({
      title: 'Voulez-vous mettre en avant cette annonce ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromoteService.enablePromote(prost?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Annonce mise en avant avec succés.',
              showConfirmButton: false,
              timer: 3000
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
          }
        )
      }
    })
  }

  disablePostPromote(prost:PostPromote){
    Swal.fire({
      title: 'Désactiver cette mise en avant.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.postPromoteService.disablePromote(prost?.id).subscribe(
          rs=> {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Annonce désactivée avec succés.',
              showConfirmButton: false,
              timer: 1500
            });
            this.reloadComponent();
          }, error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 3000
            })
        })
      }
    })
  }


  get getPost() { return this.postSubscribeForm.controls; }

  postSubscribeForm = this.fb.group({
    startDate : new FormControl("" , [Validators.required, CustomValidators.startDateNotBeforeToday]),
    endDate : new FormControl("" , [Validators.required]),
  });

  selectedStartDate : any;
  selectedEndDate : any;
  startDateNotAfterEndDate = false;
  startDateNotBeforeDateNow = false;
  endDateNotAfterStartDate = false;
  startDateNotEqualsEndDate = false;
  getSelectedDate() {
    this.selectedStartDate = this.postSubscribeForm.get('startDate')?.value;
    if(this.selectedStartDate > this.selectedEndDate){
      this.startDateNotAfterEndDate = true;
    }
  }

  getSelectedEndDate() {
    const startDateString = this.postSubscribeForm.get('startDate')?.value;
    const endDateString = this.postSubscribeForm.get('endDate')?.value;

    // Conversion des chaînes en objets Date
    this.selectedStartDate = new Date(startDateString);
    this.selectedEndDate = new Date(endDateString);

    if (this.selectedStartDate > this.selectedEndDate) {
      this.startDateNotAfterEndDate = true;
    } else {
      this.startDateNotAfterEndDate = false;
    }

    if (this.selectedStartDate.getTime() === this.selectedEndDate.getTime()) {
      this.startDateNotEqualsEndDate = true;
    } else {
      this.startDateNotEqualsEndDate = false;
    }

    const oneHourInMilliseconds = 60 * 60 * 1000;

    if (this.selectedEndDate.getTime() - this.selectedStartDate.getTime() < oneHourInMilliseconds) {
      this.endDateNotAfterStartDate = true;
    } else {
      this.endDateNotAfterStartDate = false;
    }
  }


  currentProduct: Product;
  onViewSubscribe(subscribId: any) {
    this.susbscriptionService.getByIdSubscribe(subscribId?.id).subscribe(rs=>{
      this.currentSubscribe = rs;

        this.userService.getByUSerName(this.currentSubscribe?.username).subscribe(rs=>{
        this.CurrentUsername = rs.firstname + " " + rs.lastname
        })
        // console.log("  this.currentSubscribe = rs;", this.currentSubscribe)
        // this.productService.getSubProductbySubproductId(this.currentSubscribe?.subProductId).subscribe(rs=>{
        //   this.photoUrl = rs.photo

        //   console.log(" this.photoUrl ",  this.photoUrl )
        //   })
       this.orderItemService.getIdOrderByOrderID(this.currentSubscribe.orderId).subscribe(rs=>{
          this.order = rs
        //  console.log("this.order = rs", this.order);
      });
     
    })
  }

  isoequalstoname = false;
  verifySubscribeName(){
    return null;
  }


  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  updatedPostPromote : IPostPromote;
  onEditPromote(promo: any) {
    this.updatedPostPromote = promo;
    this.postSubscribeForm = this.fb.group({
      startDate : new FormControl(this.updatedPostPromote.startDate , [Validators.required, NameValidator.startDateNotBeforeToday]),
      endDate : new FormControl(this.updatedPostPromote.endDate , [Validators.required]),
    });
  }

  loadSubscription() {
    this.susbscriptionService.allPostAbonnement(this.pageNumber - 1, this.pageSize).subscribe((data: any) => {
      this.allSubscribe = data.content;
      this.allSubscribeTmp = data.content;
      this.totalItems = data.totalElements;
      this.isFiltreDate = false;
      // console.log("  this.allSubscribe",  this.allSubscribe)
    this.allSubscribe.forEach((el, index) => {
      this.userService.getByUSerName(el.username).subscribe((rs: any) => {
      
        this.allSubscribe[index].user = rs;
      });
    });
     
      }, (err) => {
        // console.log('-----> err', err);
    });
  }



  perPage = 10;
  displayPerPage(itemsPerPage: any) {
    this.pageSize = itemsPerPage;
    this.loadSubscription();
  }

  getProductShopName(products: any[]): any[] {

    products.forEach(element => {
      if(element?.post?.postSubProducts[0]){
        this.productService.getProductbyProductId(element?.post?.postSubProducts[0]?.subProduct?.productID).subscribe(rs=>{
          element.shopName = rs?.shop?.name;
          element.price = element?.post?.postSubProducts[0]?.finalPrice;
          element.reference = element?.post?.postSubProducts[0]?.subProduct?.subProductID;
        })
      }else if(element?.post?.postServiceModels[0]){
        element.shopName = element?.post?.postServiceModels[0]?.serviceModel?.shop?.name;
        element.price = element?.post?.postServiceModels[0]?.finalPrice;
        element.reference = element?.post?.postServiceModels[0]?.serviceID;
      }
    })
    return products;
  }


  beginDateVal: any = null;
  displayErrorMessage: boolean = false;
  getBeginDate(event: any) {
    this.beginDateVal = event.target.value;
    if(this.beginDateVal != null){
      this.disableEndDate = false;
      if(this.beginDateVal > this.endDateVal){
        this.displayErrorMessage = true;
      }else {
        this.displayErrorMessage = false;
      }
    }
  }
  // Récupération de la date de fin

  endDateVal: any = null;
  disableEndDate: boolean = true;
  getEndDate(event: any) {
    this.endDateVal = event.target.value;
    //console.log(this.endDateVal);
    if(this.beginDateVal > this.endDateVal){
      this.displayErrorMessage = true;
    }else{
      this.displayErrorMessage = false;
    }
  }

  refresh() {
    this.loadSubscription();
    this.dateForm.patchValue({
      beginDate: '',
      endDate: ''
    })
  }


 
  dateForm = this.fb.group({
    beginDate: new FormControl(''),
    endDate: new FormControl('')
  })

  filterByDate() {
    const beginDate = new Date(this.dateForm.get('beginDate').value).toISOString();
    const endDate = new Date(this.dateForm.get('endDate').value).toISOString();
    // console.log("Date sélectionnée")
    // console.log('beginDate:', beginDate);
    // console.log('endDate:', endDate);
    if (!beginDate || !endDate) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez renseigner la date de début et la date de fin',
        showConfirmButton: false,
        timer: 3500
      });
      return;
    }else{
      this.susbscriptionService.getSubscribeFilter(beginDate, endDate,this.pageNumber - 1, this.pageSize).subscribe(data =>{
        this.allSubscribe = data.content;
        this.allSubscribeTmp = data.content;
        this.totalItems = data.totalElements;
        this.isFiltreDate = true
        this.allSubscribe.forEach((el, index) => {
          this.userService.getByUSerName(el.username).subscribe((rs: any) => {
          
            this.allSubscribe[index].user = rs;
          });
        });

        this.allSubscribeTmp.forEach((el, index) => {
          this.userService.getByUSerName(el.username).subscribe((rs: any) => {
          
            this.allSubscribeTmp[index].user = rs;
          });
        });


      });
    }

   
  }



  numberOnly(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  searchFilter($event: KeyboardEvent) {
    this.allSubscribe =  this.allSubscribeTmp.filter(
      value => value.subscriptionName?.toLowerCase().includes(this.search) 
    );
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  // deletePromote(id: any) {
  //   Swal.fire({
  //     title: 'SUPPRESSION',
  //     text: 'Voulez vous vraiment supprimer le forfait pour cette utilisateur ?',
  //     showDenyButton: true,
  //     showCancelButton: false,
  //     confirmButtonText: 'OUI',
  //     denyButtonText: `NON`,
  //   }).then((result) => {
  //     /* Read more about isConfirmed, isDenied below */
  //     if (result.isConfirmed) {
  //       this.susbscriptionService.deleteAbonnement(id).subscribe(
  //         rs => {
  //         Swal.fire({
  //           position: 'top-end',
  //           icon: 'success',
  //           title: 'Le forfait a été supprimer avec succès.',
  //           showConfirmButton: false,
  //           timer: 1500
  //         });
  //         this.loadSubscription();
  //       },error =>{
  //         Swal.fire({
  //           position: 'top-end',
  //           icon: 'error',
  //           title: error.error.errorMessage,
  //           showConfirmButton: false,
  //           timer: 4500
  //         });
  //       });
  //     } else if (result.isDenied) {
  //       Swal.fire({
  //         icon: 'error',
  //         text: 'Suppression annulée',

  //       })
  //     }
  //   })
  // }

  // deleteForfait(prod:ISubscriptionModel){
  //   Swal.fire({
  //     title: 'Voulez-vous vraiment supprimer ce forfait ?',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonText: 'Non',
  //     confirmButtonText: 'Oui'
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.susbscriptionService.deleteAbonnement(prod).subscribe(
  //         rs=> {
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'success',
  //             title: 'Votre forfait est supprimé de la liste avec succès.',
  //             showConfirmButton: false,
  //             timer: 1500
  //           });
  //           this.loadSubscription();
  //           this.reloadComponent();
  //         }, error => {
  //           // console.log(error);
  //           Swal.fire({
  //             position: 'top-end',
  //             icon: 'error',
  //             title: error.error.errorMessage,
  //             showConfirmButton: false,
  //             timer: 5500
  //           })
  //         }
  //       )
  //     }
  //   })

  // }

  // getTranslatedValue(value: string, name: string): string {
  //   if (!value && value !== "0") {
  //     return "0"; // Si la valeur est vide ou non définie, afficher "zéro"
  //   }  
  //   if (value !== undefined) {
  //     let valueCharacteristic: number = parseInt(value);
  //     // Effectuer la conversion en fonction du nom de la caractéristique
  //     if (name !== undefined) {
  //       if (name.includes(this.slugDureeAnnoncePublie) || 
  //           name.includes(this.slugDureeAnnonceMiseEnAvant) || 
  //           name.includes(this.slugDureeAbonnement) ||
  //           name.includes(this.slugDureePass)) {
  //         // Conversion pour les durées annoncées
  //         let durationInMonths: number = Math.round(valueCharacteristic / (24 * 1)); 
  //         return `${durationInMonths} jour(s)`;
  //       } else if (name.includes(this.slugGestionAgenda)) {
  //         if (valueCharacteristic !==0){
  //           return "Oui"
  //         }
  //         return "Oui";
  //       } else if (name.includes(this.slugGestionDesCommandes)) {
  //         if (valueCharacteristic !==0){
  //           return "Oui"
  //         }
  //         return "Non";
  //       }else if (name.includes(this.slugStatistiqueClient)) {
  //         if (valueCharacteristic !==0){
  //           return "Oui"
  //         }
  //         return "Non";
  //       }else if (name.includes(this.slugAnnonceBanniere) && valueCharacteristic === 0) {
  //         return "0";
  //       }else if (name.includes(this.slugPubliciteSponsoriseAnnonce) && valueCharacteristic === 0) {
  //         return "0";
  //       } else if (name.includes(this.slugOrganisationDesPromotions)) {
  //         if (valueCharacteristic !==0){
  //           return "Oui"
  //         }
  //         return "Non";
  //       } else if (name.includes(this.slugCampagneCommunicationPromotion)) {
  //         if (valueCharacteristic !==0){
  //           return "Oui"
  //         }
  //         return "Non";
  //       } else if (name.includes(this.slugAnnonceMiseEnAvant) && valueCharacteristic === 0) {
  //         return "0";
  //       } else {
  //         return value; // Retourne la valeur telle quelle si aucune conversion n'est nécessaire
  //       }
  //     }
  //   }
  
  //   return "0"; // Valeur par défaut si la valeur n'est pas définie ou si la conversion ne s'applique pas
  // }

  getTranslatedValue(value: string, name: string): string {
    if (!value && value !== "0") {
      return "0"; // Si la valeur est vide ou non définie, afficher "zéro"
    }  
    if (value !== undefined) {
      let valueCharacteristic: number = parseInt(value);
      // Effectuer la conversion en fonction du nom de la caractéristique
        let durationInHours: number
        let durationInDays: number                         
        let durationInMonths: number
      if (name !== undefined) {
         if( (name.includes(this.slugDureeAbonnement) || name.includes(this.slugDureeAnnoncePublie) || name.includes(this.slugDureeAnnonceMiseEnAvant) || name.includes(this.slugDureeEmploiPublie) || name.includes(this.slugDureeEmploiMiseEnAvant)) && valueCharacteristic >=24 ) {
         durationInHours = valueCharacteristic;
         durationInDays = Math.round(durationInHours / 24); 
         durationInMonths = Math.round(durationInDays / 1); 
      return `${durationInMonths} Jour(s)`;
     }else if( (name.includes(this.slugDureeAbonnement) || name.includes(this.slugDureeAnnoncePublie) || name.includes(this.slugDureeAnnonceMiseEnAvant) || name.includes(this.slugDureeEmploiPublie) || name.includes(this.slugDureeEmploiMiseEnAvant)) && valueCharacteristic < 24 ) {
      durationInHours = valueCharacteristic;
      durationInDays = Math.round(durationInHours / 24); 
      durationInMonths = Math.round(durationInDays / 1); 
    return `${durationInHours} Heure(s)`;
    } else if (name.includes(this.slugEnableGestionAgenda)) {
          if (valueCharacteristic !==0){
            return "Oui"
          }
          return "Oui";
          
        }else if (name.includes(this.slugEnableSellerPromotion)) {
          if (valueCharacteristic !==0){
            return "Oui"
          }
          return "Oui";
          
        } else if (name.includes(this.slugEnableGestionDesCommandes)) {
          if (valueCharacteristic !==0){
            return "Oui"
          }
          return "Non";
        }else if (name.includes(this.slugEnableStatistiqueClient)) {
          if (valueCharacteristic !==0){
            return "Oui"
          }
          return "Non";
        }else if (name.includes(this.slugAnnonceBanniere) && valueCharacteristic === 0) {
          return "0";
        }else if (name.includes(this.slugPubliciteSponsoriseAnnonce) && valueCharacteristic === 0) {
          return "0";
        } else if (name.includes(this.slugOrganisationDesPromotions)) {
          if (valueCharacteristic !==0){
            return "Oui"
          }
          return "Non";
        } else if (name.includes(this.slugEnableCampagneCommunicationPromotion)) {
          if (valueCharacteristic !==0){
            return "Oui"
          }
          return "Non";
        } else if (name.includes(this.slugAnnonceMiseEnAvant) && valueCharacteristic === 0) {
          return "0";
        } else {
          return value; // Retourne la valeur telle quelle si aucune conversion n'est nécessaire
        }
      }
    }
  
    return "0"; // Valeur par défaut si la valeur n'est pas définie ou si la conversion ne s'applique pas
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.subscriptionName > b.subscriptionName ? 1 : a.subscriptionName < b.subscriptionName ? -1 : 0)
      this.sorted1 = true;
    } else {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.subscriptionName < b.subscriptionName ? 1 : a.subscriptionName > b.subscriptionName ? -1 : 0)
      this.sorted1 = false;
    }
  }



  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.username > b.username ? 1 : a.username < b.username ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.username < b.username ? 1 : a.username > b.username ? -1 : 0)
      this.sorted3 = false;
    }
  }

  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.startDate > b.startDate ? 1 : a.startDate < b.startDate ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.startDate < b.startDate ? 1 : a.startDate > b.startDate ? -1 : 0)
      this.sorted4 = false;
    }
  }

  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.endDate > b.endDate ? 1 : a.endDate < b.endDate ? -1 : 0)
      this.sorted5 = true;
    } else {
      // @ts-ignore
      this.allSubscribe.sort((a, b) => a.endDate < b.endDate ? 1 : a.endDate > b.endDate ? -1 : 0)
      this.sorted5 = false;
    }
  }


  strUcFirst(valeur : any){return (valeur+'').charAt(0).toUpperCase()+valeur.substr(1);}


  minDate(): string {
    const today = new Date();
    return today.toISOString().slice(0, 16); // Format ISO pour la date et l'heure.
  }

  exportPostToExelFile(filename: string) {
    const data = document.getElementById('tab-forfait');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(data);

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, filename);
  }

  selectForfaitType(value: string) {
    this.allSubscribe = [];
    if (value === "all") {
      this.loadSubscription();
    } else if (value === "forfait") {
      this.susbscriptionService.allPostForfaitAbonnement(0,1000).subscribe((rs:any) => {
       this.allSubscribeTmp = rs.content;
       this.allSubscribe = rs.content;
       this.allSubscribe.forEach((el, index) => {
        this.userService.getByUSerName(el.username).subscribe((rs: any) => {
        
          this.allSubscribe[index].user = rs;
        });
      });
    
        });
        
      }
     else if (value === "pass") {
      this.susbscriptionService.allPostPassAbonnement(0,1000).subscribe((rs:any) => {
        this.allSubscribeTmp = rs.content;
        this.allSubscribe = rs.content;
        this.allSubscribe.forEach((el, index) => {
          this.userService.getByUSerName(el.username).subscribe((rs: any) => {
          
            this.allSubscribe[index].user = rs;
          });
        });
      
         });
         
    } 
  }

  pagination(){
    if(this.isFiltreDate){
      this.filterByDate()
    }
    else{
      this.loadSubscription()
    }
    
  }

}
